import React from "react";
import {NavLink} from "react-router-dom";
import shapeIconBottom from "../../images/shapes/shape_ico_hero_section_bottom.svg";

const Footer = () => {
  return (
    <footer className="ico_site_footer section_decoration section_shadow_top">
      <div className="decoration_item shape_top">
        <img src={shapeIconBottom} alt="Bottom Line Shape" />
      </div>
      <div className="container">
        <div className="footer_bottom text-center">
          <p className="copyright_text m-0 text-secondary mb-3">
            © 2025 crucoin.ai. Todos los derechos reservados.
          </p>
          <div className="footer_links">
            <NavLink
              to="/legal/terms-and-conditions.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="footer_link"
            >
              Términos
            </NavLink>
            <span className="footer_separator">·</span>
            <NavLink
              to="/legal/privacy-policy.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="footer_link"
            >
              Privacidad
            </NavLink>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
